import './ReviewLoaded.scss';

import React, {Component} from 'react';
import Rating from 'react-rating';
import Star from 'react-feather/dist/icons/star.js';
import {toastr} from 'react-redux-toastr';
import PropTypes from 'prop-types';

import conf from '../../../../../conf.js';
import api from '../../../../../../api.js';

import './ReviewLoaded.scss';

export default class ReviewLoaded extends Component {
  static propTypes = {
    freelanceId: PropTypes.number.isRequired,
    globalRating: PropTypes.number,
    humanSkills: PropTypes.array,
    reviewId: PropTypes.number,
    setReviewId: PropTypes.func.isRequired,
    skills: PropTypes.array,
  };

  static defaultProps = {
    globalRating: 0,
    humanSkills: [],
    reviewId: null,
    skills: [],
  };

  constructor(props) {
    super(props);
    const parentSkills = {humanSkills: {}, skills: {}};

    Object.keys(parentSkills).forEach(key => {
      parentSkills[key] = props[key].reduce((acc, skill) => ({
        ...acc,
        [skill.id]: {id: skill.id, name: skill.name, rate: skill.rate}
      }), {});
    });

    this.state = {
      globalRating: props.globalRating,
      parentSkills
    };
    this.handleSkillsChange.bind(this)
  }

  handleGlobalRatingChange = async (newGlobalRating) => {
    this.setState({globalRating: newGlobalRating}, this.updateReview);
  }

  handleSkillsChange = async (key, review) => {
    const parentSkills = this.state.parentSkills;
    parentSkills[key][review.id].rate = review.rate;
    this.setState({parentSkills}, this.updateReview);
  }

  updateReview = async () => {
    try {
      const newValues = {
        freelance: this.props.freelanceId,
        review: this.props.reviewId ? this.props.reviewId : 'N/A',
        type: conf.reviewType.admin,
        global_rating: this.state.globalRating,
        human_skills: this.normalizeSkills(this.state.parentSkills.humanSkills),
        skills: this.normalizeSkills(this.state.parentSkills.skills),
      };

      if (null !== this.props.reviewId) {
        await api.freelances.reviews.edit({...newValues});
      } else {
        const reviewId = (await api.freelances.reviews.add({...newValues})).data.id;
        this.props.setReviewId(reviewId);
      }

      this.props.updateReviews()

      toastr.success('La notation du freelance a bien été mise à jour.');
    }
    catch (e) {
      toastr.error('La notation du freelance n\'a pas pu être mise à jour.', {timeOut: 0});
      console.warn(e);
    }
  }

  normalizeSkills = (skills) => {
    return Object.values(skills).filter(skill => skill.rate).map(skill => ({skill: skill.id, rate: skill.rate}));
  }

  emptyStar = () => {
    return <Star strokeWidth={0} fill="#bdc8d8"/>;
  }

  fullStar = () => {
    return <Star strokeWidth={0} fill="#FF942D"/>;
  }

  renderSkillRating = (skill, key) => {
    return (
      <div key={skill.id} className="d-flex label-align align-items-center">
        <span>{skill.name}</span>
        {this.renderRating(
          (value) => this.handleSkillsChange(key, {id: skill.id, rate: value}),
          skill.rate
        )}
      </div>
    );
  }

  renderRating = (onChange, initialRating = 0) => {
    return (
      <Rating
        emptySymbol={this.emptyStar()}
        fullSymbol={this.fullStar()}
        fractions={2}
        start={0}
        stop={5}
        initialRating={initialRating}
        onChange={onChange}
      />
    );
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="d-flex label-align align-items-start">
            <span>Séniorité globale</span>
            {this.renderRating(this.handleGlobalRatingChange, this.state.globalRating)}
          </div>
          {Object.values(this.state.parentSkills.humanSkills).map((skill) => {
            return this.renderSkillRating(skill, 'humanSkills')
          })}
        </div>
        <div className="col-md-6">
          {Object.values(this.state.parentSkills.skills).map((skill) => {
            return this.renderSkillRating(skill, 'skills')
          })}
        </div>
      </div>
    );
  }
}
